import { createBlockStyleButton } from "@draft-js-plugins/buttons";

export default createBlockStyleButton({
  blockType: "header-five",
  children: "H5",
});
